export function APIClient() {
    return {
        /* Authentication */
        login: (username, password) => sendRequest('/auth/login', 'POST', {
            username,
            password
        }),
        logout: () => sendRequest('/auth/logout'),
        getLoggedUser: () => sendRequest('/auth/get'),

        /* Article */
        getArticles: (filter) => sendRequest('/articles', 'GET', filter),
        deleteArticle: (articleId) => sendRequest('/articles/' + articleId, 'DELETE'),
        saveArticle: (data) => sendRequest('/articles', 'POST', data),
        getArticle: (articleId) => sendRequest('/articles/' + articleId),
        getArticlesLastPrice: (categoryId, articleName, retailerIds, brandIds, countryIds) => sendRequest('/articles/prices', 'GET', { categoryId, retailerIds, articleName, brandIds, countryIds }),
        saveArticlePrice: (articleId, retailerId, price) => sendRequest('/articles/prices', 'POST', { price, articleId, retailerId }),
        getArticleScanners: (articleId) => sendRequest('/articles/' + articleId + '/scanners'),
        upsertArticleScanner: (articleId, retailerId, url) => sendRequest('/articles/' + articleId + '/scanners', 'POST', { url, retailerId }),

        /* Brands */
        getBrands: () => sendRequest('/brands'),
        getBrand: (brandId) => sendRequest('/brands/' + brandId),
        deleteBrand: (brandId) => sendRequest('/brands/' + brandId, 'DELETE'),
        saveBrand: (data) => sendRequest('/brands', 'POST', data),

        /* Category */
        getCategories: () => sendRequest('/categories'),
        getCategory: (categoryId) => sendRequest('/categories/' + categoryId),
        deleteCategory: (categoryId) => sendRequest('/categories/' + categoryId, 'DELETE'),
        saveCategory: (data) => sendRequest('/categories', 'POST', data),

        /* Countries */
        getCountries: () => sendRequest('/countries', 'GET'),
        getCountry: (countryId) => sendRequest('/countries/' + countryId),
        deleteCountry: (countryId) => sendRequest('/countries/' + countryId, 'DELETE'),
        saveCountry: (data) => sendRequest('/countries', 'POST', data),

        /* Retailers */
        getRetailers: () => sendRequest('/retailers', 'GET'),
        getRetailer: (retailerId) => sendRequest('/retailers/' + retailerId),
        deleteRetailer: (retailerId) => sendRequest('/retailers/' + retailerId, 'DELETE'),
        saveRetailer: (data) => sendRequest('/retailers', 'POST', data),

        /* Users */
        getUsers: () => sendRequest('/users'),
        getUser: (userId) => sendRequest('/users/' + userId),
        deleteUser: (userId) => sendRequest('/users/' + userId, 'DELETE'),
        saveUser: (data) => sendRequest('/users', 'POST', data),
    };
}

function sendRequest(path, method = 'GET', data = {}, contentType = 'application/json') {
    const headers = new Headers();
    const parameters = {
        method: method,
        headers: headers,
    };

    let _path = path;
    if (method === 'GET' && data && Object.values(data).filter((value) => value !== undefined).length > 0) {
        const queryString = getQueryString(data);
        _path += '?' + queryString;
    }
    if (method !== 'GET') {
        parameters.body = data;
        if (contentType === 'application/json') {
            parameters.body = JSON.stringify(data);
            headers.append('Content-Type', contentType);
        }
    }

    return fetch(_path, parameters)
        .then((resp) => handleErrors(resp))
}

async function handleErrors(resp) {
    if (resp.ok) {
        if (resp.status === 200 || resp.status === 201) {
            const contentType = resp.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                return resp.json();
            }
        }
    } else {
        console.log(resp);
        if (resp.status === 403) {
            window.location.href = '/';
        }
    }
}

function getQueryString(data) {
    const encodedUriComponents = [];
    Object.keys(data).forEach((key) => {
        if (data[key]) {
            encodedUriComponents.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
        }
    });
    return encodedUriComponents.join('&');
}
